import { api } from '../../../../redux/setupAxios';

const CHALLENGES_URL = 'challenges';
const FEED_URL = 'feed';

export const fetchQuizzes = async ({ merchantId }) => {
    try {
        const { data } = await api.get(`${CHALLENGES_URL}/quiz`, {
            params: {
                merchantId
            },
        });
        return data;
    } catch (err) {
        return [];
    }
};

export const createQuiz = async ({ quiz, }) => {
    const { data } = await api.post(`${CHALLENGES_URL}/quiz`, {
        quiz,
    });
    return data;
};

export const deleteQuiz = async quiz => {
    return await api.delete(`${CHALLENGES_URL}/quiz/${quiz._id}`);
};

export const getUploadUrl = async ({ image }) => {
    const res = await api.post(`${FEED_URL}/get-upload-url`, {
        fileType: image.type,
    });
    return res;
}